import type {ConferenceApiModel} from '../../../api/conference';
import type {Nullable} from '../../utility-types';

export const isConferenceCorporate = (
  conference?: Nullable<ConferenceApiModel>,
) => !!conference?.subtenant_id;
